import React, { useState } from 'react';
import { Table, Button, Form, Row, Col, Card } from 'react-bootstrap';
import { FaPlus, FaSave, FaTimes, FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';

const emptyForm = {
  codigo_grupo_empresa: '', codigo_conta: '',
  ge1: '', cred1: '', deb1: '',
  ge2: '', cred2: '', deb2: '',
  ge3: '', cred3: '', deb3: '',
  gef: '', cred_f: '', deb_f: '',
};

const GridTransfComissao = ({ codigoFamilia, transferencias, onRecarregar }) => {
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(emptyForm);
  const [salvando, setSalvando] = useState(false);

  const handleAbrirForm = () => {
    setForm(emptyForm);
    setShowForm(true);
  };

  const setField = (name, value) => setForm((prev) => ({ ...prev, [name]: value }));

  const toInt = (v) => (v !== '' ? Number(v) : null);

  const handleIncluir = async () => {
    if (!form.codigo_grupo_empresa || !form.codigo_conta) {
      toast.warn('Informe GE e Conta');
      return;
    }
    setSalvando(true);
    try {
      await api.salvarTransfComissao({
        familia: codigoFamilia,
        codigo_grupo_empresa: toInt(form.codigo_grupo_empresa),
        codigo_conta: toInt(form.codigo_conta),
        ge1: toInt(form.ge1), cred1: toInt(form.cred1), deb1: toInt(form.deb1),
        ge2: toInt(form.ge2), cred2: toInt(form.cred2), deb2: toInt(form.deb2),
        ge3: toInt(form.ge3), cred3: toInt(form.cred3), deb3: toInt(form.deb3),
        gef: toInt(form.gef), cred_f: toInt(form.cred_f), deb_f: toInt(form.deb_f),
      });
      toast.success('Transferência incluída com sucesso!');
      setShowForm(false);
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao incluir transferência';
      toast.error(msg);
    } finally {
      setSalvando(false);
    }
  };

  const handleExcluir = async (item) => {
    if (!window.confirm(`Excluir transferência GE ${item.codigo_grupo_empresa} / Conta ${item.codigo_conta}?`)) return;
    try {
      await api.excluirTransfComissao({
        familia: codigoFamilia,
        codigo_conta: item.codigo_conta,
        codigo_grupo_empresa: item.codigo_grupo_empresa,
      });
      toast.success('Transferência excluída!');
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao excluir transferência';
      toast.error(msg);
    }
  };

  const NumInput = ({ name, label, md }) => (
    <Col md={md || 2}>
      <Form.Group>
        <Form.Label className="small mb-1">{label}</Form.Label>
        <Form.Control type="number" value={form[name]} onChange={(e) => setField(name, e.target.value)} />
      </Form.Group>
    </Col>
  );

  return (
    <Card className="mb-3">
      <Card.Header className="d-flex justify-content-between align-items-center py-2">
        <strong>Transferência de Comissão</strong>
        <Button size="sm" variant="outline-primary" onClick={handleAbrirForm}>
          <FaPlus className="mr-1" /> Incluir
        </Button>
      </Card.Header>
      <Card.Body className="p-0">
        {showForm && (
          <div className="p-3 border-bottom bg-light">
            <Row>
              <NumInput name="codigo_grupo_empresa" label="GE" md={3} />
              <NumInput name="codigo_conta" label="Conta" md={3} />
            </Row>
            <Row className="mt-2">
              <Col md={12}><small className="text-muted font-weight-bold">1ª Mata</small></Col>
              <NumInput name="ge1" label="GE" />
              <NumInput name="cred1" label="Cred" />
              <NumInput name="deb1" label="Deb" />
            </Row>
            <Row className="mt-2">
              <Col md={12}><small className="text-muted font-weight-bold">2ª Mata</small></Col>
              <NumInput name="ge2" label="GE" />
              <NumInput name="cred2" label="Cred" />
              <NumInput name="deb2" label="Deb" />
            </Row>
            <Row className="mt-2">
              <Col md={12}><small className="text-muted font-weight-bold">3ª Mata</small></Col>
              <NumInput name="ge3" label="GE" />
              <NumInput name="cred3" label="Cred" />
              <NumInput name="deb3" label="Deb" />
            </Row>
            <Row className="mt-2">
              <Col md={12}><small className="text-muted font-weight-bold">Fundo de Reserva</small></Col>
              <NumInput name="gef" label="GE" />
              <NumInput name="cred_f" label="Cred" />
              <NumInput name="deb_f" label="Deb" />
            </Row>
            <div className="mt-2">
              <Button size="sm" variant="success" className="mr-2" onClick={handleIncluir} disabled={salvando}>
                <FaSave className="mr-1" /> Salvar
              </Button>
              <Button size="sm" variant="secondary" onClick={() => setShowForm(false)} disabled={salvando}>
                <FaTimes className="mr-1" /> Cancelar
              </Button>
            </div>
          </div>
        )}
        <div style={{ maxHeight: 300, overflow: 'auto' }}>
          <Table striped bordered hover size="sm" className="mb-0" style={{ minWidth: 1100 }}>
            <thead>
              <tr>
                <th rowSpan={2}>GE</th>
                <th rowSpan={2}>Conta</th>
                <th colSpan={3} className="text-center">1ª Mata</th>
                <th colSpan={3} className="text-center">2ª Mata</th>
                <th colSpan={3} className="text-center">3ª Mata</th>
                <th colSpan={3} className="text-center">Fdo.Reserva</th>
                <th rowSpan={2}>Ações</th>
              </tr>
              <tr>
                <th>GE</th><th>Cred</th><th>Deb</th>
                <th>GE</th><th>Cred</th><th>Deb</th>
                <th>GE</th><th>Cred</th><th>Deb</th>
                <th>GE</th><th>Cred</th><th>Deb</th>
              </tr>
            </thead>
            <tbody>
              {transferencias.length === 0 && (
                <tr>
                  <td colSpan={15} className="text-center text-muted">
                    Nenhuma transferência cadastrada
                  </td>
                </tr>
              )}
              {transferencias.map((item) => (
                <tr key={`${item.codigo_grupo_empresa}-${item.codigo_conta}`}>
                  <td>{item.codigo_grupo_empresa}</td>
                  <td>{item.codigo_conta}</td>
                  <td>{item.ge1}</td>
                  <td>{item.cred1}</td>
                  <td>{item.deb1}</td>
                  <td>{item.ge2}</td>
                  <td>{item.cred2}</td>
                  <td>{item.deb2}</td>
                  <td>{item.ge3}</td>
                  <td>{item.cred3}</td>
                  <td>{item.deb3}</td>
                  <td>{item.gef}</td>
                  <td>{item.cred_f}</td>
                  <td>{item.deb_f}</td>
                  <td>
                    <Button size="sm" variant="outline-danger" title="Excluir" onClick={() => handleExcluir(item)}>
                      <FaTrash />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default GridTransfComissao;
